import { render } from "./DocumentsCrudList.vue?vue&type=template&id=079eaa1b&scoped=true"
import script from "./DocumentsCrudList.vue?vue&type=script&lang=js"
export * from "./DocumentsCrudList.vue?vue&type=script&lang=js"

import "./DocumentsCrudList.vue?vue&type=style&index=0&id=079eaa1b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079eaa1b"]])

export default __exports__